import { render } from "./AddContactView.vue?vue&type=template&id=50bf5dd8&scoped=true"
import script from "./AddContactView.vue?vue&type=script&lang=js"
export * from "./AddContactView.vue?vue&type=script&lang=js"

import "./AddContactView.vue?vue&type=style&index=0&id=50bf5dd8&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50bf5dd8"]])

export default __exports__